module.exports = __webpack_public_path__ + "img/remove_circle_outline.4acf7d3a.svg";